import { render, staticRenderFns } from "./devicebelonglist.vue?vue&type=template&id=10fccb58&scoped=true&"
import script from "./devicebelonglist.vue?vue&type=script&lang=js&"
export * from "./devicebelonglist.vue?vue&type=script&lang=js&"
import style0 from "./devicebelonglist.vue?vue&type=style&index=0&id=10fccb58&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10fccb58",
  null
  
)

export default component.exports